
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jeux/mystere",
      function () {
        return require("private-next-pages/jeux/mystere.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jeux/mystere"])
      });
    }
  